/**
 * vuex 状态管理
 */
import Vue from 'vue'
import Vuex from 'vuex'
import veri from './modules/veri'

Vue.use(Vuex)

const state = {
  loading: {
    status: false,
    text: '',
    time: 0
  },
  direction: 'forward',
  toast: {
    show: false,
    text: '',
    time: 1000
  },
  report: null,
  authPrefix: '/auth/weixin/'
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations: {
    UPDATE_LOADING (state, loading) {
      state.loading = Object.assign({}, state.loading, loading)
    },
    UPDATE_DIRECTION (state, direction) {
      state.direction = direction
    },
    UPDATE_TOAST (state, toast) {
      state.toast = Object.assign({}, toast)
    },
    UPDATE_REPORT (state, report) {
      state.report = report
    }
  },
  actions: {
    UPDATE_TOAST ({commit}, toast) {
      commit('UPDATE_TOAST', toast)
      let st = null
      clearTimeout(st)
      st = setTimeout(() => {
        toast.show = false
        commit('UPDATE_TOAST', toast)
      }, toast.time)
    }
  },
  modules: {
    veri
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js